import React, { useEffect, useState } from "react";
import axios from "axios";

/* ===== COMPONENTS ===== */
import LandingPage from "../components/LandingPage";
import PersonalProfile from "../components/PersonalProfile";
import WorkPreferences from "../components/WorkPreferences";
import ExperienceSection from "../components/ExperienceSection";
import EducationSection from "../components/EducationSection";
import SkillsSection from "../components/SkillsSection";
import QualificationsSection from "../components/QualificationsSection";
/* ===== STYLES ===== */
import "../styles/GlobalStyles.css";

const ProfilePage = () => {
  const [user, setUser] = useState(null);

  const [selectedSection, setSelectedSection] = useState(null);
  const [formMode, setFormMode] = useState("add"); // add | edit
  const [editingItem, setEditingItem] = useState(null);

  /* ================= FETCH PROFILE ================= */
  const fetchProfile = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return;

      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/profile/getCandProfile`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const c = res.data.candidate;

      setUser({
        name: `${c.first_name || ""} ${c.last_name || ""}`.trim(),
        gender: c.gender || "",
        email: c.email || "",
        phone: c.phone_number || "",
        alternate_number: c.alternate_no || "",

        dob: c.date_of_birth ? c.date_of_birth.split("T")[0] : "",
        age: c.date_of_birth
          ? new Date().getFullYear() -
          new Date(c.date_of_birth).getFullYear()
          : "",

        address: {
          street: c.address?.street || "",
          area: c.address?.area || "",
          city: c.address?.city || "",
          state: c.address?.state || "",
          postal_code: c.address?.postal_code || "",
          country: c.address?.country || "",
        },

        qualification: c.qualification || [],

        professional_Description: c.professional_Description || "",

        work_preference: c.work_preference || {},
        notice_period: c.notice_period || "",

        salary: c.salary || "",
        current_salary: c.work_experience?.[0]?.salary || "",

        linkedin: c.linkedin_profile || "",
        resume: c.resume || "",
        profilePic: c.profilePic || "",

        work_experience: c.work_experience || [],
        education: c.education || [],
        skills: c.skills || [],

      });
    } catch (err) {
      console.error("Failed to load profile", err);
    }
  };

  /* ================= INITIAL LOAD ================= */
  useEffect(() => {
    fetchProfile();
  }, []);

  /* ================= BODY SCROLL LOCK ================= */
  useEffect(() => {
    if (selectedSection) {
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.top = "0";
      document.body.style.width = "100%";
    } else {
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
    }

    // ✅ CRITICAL CLEANUP
    return () => {
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
    };
  }, [selectedSection]);



  /* ================= OPEN ADD ================= */
  const openAdd = (section) => {
    setFormMode("add");
    setEditingItem(null);
    setSelectedSection(section);
  };

  /* ================= OPEN EDIT ================= */
  const openEdit = (section, data) => {
    setFormMode("edit");
    setEditingItem(data || null);

    // ✅ DO NOT MUTATE OR FLATTEN USER STATE
    setSelectedSection(section);
  };

  /* ================= CLOSE DRAWER ================= */
  const closeDrawer = async () => {
    await fetchProfile(); // refresh after save
    setSelectedSection(null);
    setFormMode("add");
    setEditingItem(null);
  };

  /* ================= DRAWER CONTENT ================= */
  const renderDrawerContent = () => {
    switch (selectedSection) {
      case "personalProfile":
        return (
          <PersonalProfile
            user={user}
            setUser={setUser}
            onSuccess={closeDrawer}
          />
        );

      case "workPreferences":
        return (
          <WorkPreferences
            mode={formMode}
            initialData={editingItem}
            onSuccess={closeDrawer}
          />
        );

      case "experience":
        return (
          <ExperienceSection
            mode={formMode}
            initialData={editingItem}
            onClose={closeDrawer}
          />
        );

      case "education":
        return (
          <EducationSection
            mode={formMode}
            initialData={editingItem}
            onClose={closeDrawer}
          />
        );

      case "skills":
        return (
          <SkillsSection
            mode={formMode}
            initialData={editingItem}
            onClose={closeDrawer}
          />
        );

      case "qualification":
        return (
          <QualificationsSection
            mode={formMode}
            initialData={editingItem}
            onClose={closeDrawer}
          />
        );



      default:
        return null;
    }
  };

  /* ================= UI ================= */
  return (
    <div className="profile-page">
      {/* DASHBOARD */}
      <LandingPage user={user} openAdd={openAdd} openEdit={openEdit} />

      {/* DRAWER */}
      {selectedSection && user && (
        <>
          <div
            className="profile-backdrop"
            onClick={closeDrawer}
          />


          <div className="profile-drawer">
            <button className="drawer-close-btn" onClick={closeDrawer}>
              ✕
            </button>

            {renderDrawerContent()}
          </div>
        </>
      )}
    </div>
  );
};

export default ProfilePage;
